import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";
import { useUserLocation } from "../lib/location";
import StateCitySelect from "../components/StateCitySelect";
import DealerCard from "../components/DealerCard";

export default function Dealers() {
  const { location } = useUserLocation();
  const [f, setF] = useState({ state: location?.state || "", city: location?.city || "", q: "" });
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const locKey = location?.city ? `${location.state}|${location.city}` : "";
  const prev = useRef(locKey);
  useEffect(() => {
    // A new city picked in the top bar re-filters the dealer list.
    if (prev.current !== locKey && location?.city) setF((p) => ({ ...p, state: location.state, city: location.city }));
    prev.current = locKey;
  }, [locKey]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    let stale = false;
    setLoading(true);
    const p = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
    axios.get(`${API}/dealers`, { params: p }).then((r) => !stale && setList(r.data)).catch(() => !stale && setList([])).finally(() => !stale && setLoading(false));
    return () => { stale = true; };
  }, [f]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28" data-testid="dealers-page">
      <p className="eyebrow mb-2">Pre-owned car dealers {f.city ? `· ${f.city}` : f.state ? `· ${f.state}` : "· All India"}</p>
      <h1 className="font-display text-4xl sm:text-5xl mb-3">Dealer Stores</h1>
      <p className="text-gray-400 max-w-2xl mb-6 text-sm">Visit showrooms near you. Every store shows its logo, address and live inventory.</p>
      <div className="lux-card p-4 grid sm:grid-cols-3 gap-3 mb-6">
        <StateCitySelect state={f.state} city={f.city} allowAll prefix="dealers-" onChange={(v) => setF({ ...f, ...v })} />
        <div><label className="lux-label">Dealer name</label><input className="lux-input" placeholder="Search dealers" onKeyDown={(e) => e.key === "Enter" && setF({ ...f, q: e.target.value })} onBlur={(e) => setF({ ...f, q: e.target.value })} data-testid="dealers-search-input" /></div>
      </div>
      <p className="text-sm text-gray-400 mb-4 flex items-center gap-3" data-testid="dealers-count">{loading ? "Loading..." : `${list.length} dealer stores`}
        {(f.state || f.city) && <button onClick={() => setF({ ...f, state: "", city: "" })} className="text-xs underline hover:text-[#E5C158]" data-testid="dealers-all-india">See all India</button>}
      </p>
      {!loading && !list.length && <div className="lux-card p-12 text-center text-gray-400" data-testid="dealers-empty">No dealer stores in {f.city || f.state || "this area"} yet.</div>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">{list.map((d) => <DealerCard key={d.id} dealer={d} />)}</div>
    </div>
  );
}
